// prettier-ignore
// @ts-expect-error incompatibility with node16 resolution
import type { PortableTextBlock, PortableTextMarkDefinition } from '@portabletext/types';

type Props = PortableTextBlock & {
    mark: PortableTextMarkDefinition & {
        phone: string;
    };
};

const LinkPhoneAnnotation = (props: Props) => {
    const { children, mark } = props;
    return (
        <a href={`tel:${mark?.phone}`}>
            <>{children}</>
        </a>
    );
};

export default LinkPhoneAnnotation;
